import 'react'
import  localization  from  '../helpers/localization';
import InputWithLabel from './InputWithLabel';
import { Form, Field } from 'react-final-form';
import StartRatingInput from './StarRatingInput';
import { contentRoot } from '../config.js';

const FeedbackPage = ({ onFeedbackSubmit,feedbackSent, onNewPlanClick, gotoStart, sendingPlan, notConnected }) => {
    if (sendingPlan) {
        return (<div className="offerSentPage">
            <img className="img-fluid" src={contentRoot + "/img/Loading_icon.gif"}></img>
            <h1>{localization.sendingOfferRequest}</h1>
        </div>);
    }
    else if (notConnected) {
        return (<div className="offerSentPage">
            <img src={contentRoot + "img/error.svg"}></img>
            <h1>{localization.failedRequestMessage}</h1>
        </div>);
    }
    else {

        return (<div className="offerSentPage">
            <picture>
                <source srcSet={contentRoot + "img/check.webp"} type="image/webp" />
                <img src={contentRoot + "img/check.png"} alt="ok" />
            </picture>
            <h1>{localization.offerRequestSent}</h1>
            <p>{localization.contactAsSoonAsPossible}</p>
            {
                !feedbackSent ? (<Form model="feedBack" hideNativeErrors={false} onSubmit={onFeedbackSubmit} render={({ handleSubmit, form, submitting, pristine, values }) => (
                    <form id="feedBackForm" onSubmit={handleSubmit}>
                        <p>{localization.askFeedBack}</p>
                        <StartRatingInput label={localization.askHowEasy} name="rating"></StartRatingInput>
                        <div className="inputWithLabel">
                            <label htmlFor="comment" className="textinputLabel">Vapaa sana</label>
                            <Field name="comment" component="textarea" />
                        </div>
                        <button className="orangeButton changePhaseButton buttonTxt" type="submit">{localization.sendFeedback}</button>
                    </form>)}>
                </Form>) : <p>{localization.thankYouForFeedback}</p>

            }
                <div className="changePhaseRow">
                    <span className="orangeButton changePhaseButton" onClick={() => { onNewPlanClick(); gotoStart(); }}> <span className="buttonTxt"> {localization.makeNewPlan}</span></span>
                </div>
        </div>);
    }
};
export default FeedbackPage;


